'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _utils = require('../../utils');

var _constants = require('../../constants');

var _CaseActivity = require('./CaseActivity');

var _CaseActivity2 = _interopRequireDefault(_CaseActivity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var parseCaseNote = _utils.FormattingUtils.parseCaseNote,
    truncate = _utils.FormattingUtils.truncate;
var ACTIVITY_TRUNCATE_LENGTH = _constants.AppConstants.ACTIVITY_TRUNCATE_LENGTH;

var CaseNote = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(CaseNote, _Component);

  function CaseNote() {
    _classCallCheck(this, CaseNote);

    return _possibleConstructorReturn(this, (CaseNote.__proto__ || Object.getPrototypeOf(CaseNote)).apply(this, arguments));
  }

  _createClass(CaseNote, [{
    key: 'render',
    value: function render() {
      var _props$activity = this.props.activity,
          body = _props$activity.body,
          mentions = _props$activity.mentions,
          parsedBody = parseCaseNote(body, mentions),
          truncatedBody = parseCaseNote(truncate(body, ACTIVITY_TRUNCATE_LENGTH), mentions);


      return _react2.default.createElement(_CaseActivity2.default, _extends({
        activity_body: parsedBody,
        truncatedBody: truncatedBody
      }, this.props, {
        deletableActivityType: true
      }));
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return CaseNote;
}(_react.Component), _class2.propTypes = {
  activity: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.string.isRequired
  }).isRequired,
  enableDelete: _propTypes2.default.bool
}, _temp)) || _class) || _class;

var _default = CaseNote;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(parseCaseNote, 'parseCaseNote', '/app/src/components/common-activities/CaseNote.js');
  reactHotLoader.register(truncate, 'truncate', '/app/src/components/common-activities/CaseNote.js');
  reactHotLoader.register(ACTIVITY_TRUNCATE_LENGTH, 'ACTIVITY_TRUNCATE_LENGTH', '/app/src/components/common-activities/CaseNote.js');
  reactHotLoader.register(CaseNote, 'CaseNote', '/app/src/components/common-activities/CaseNote.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common-activities/CaseNote.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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